<div
  class="login-dark pb-5 mb-5"
  style="overflow-y: scroll"
>
  <form
    #authForm="ngForm"
    (ngSubmit)="onSubmit(authForm)"
  >
    <div
      class="form-row"
      style="margin: 10px"
    >
      <div
        class="col-auto text-center"
        style="padding: 5px; opacity: 1; filter: blur(0px)"
      >
        <div class="bg-white border rounded shadow">
          <img
            alt="Mercer PRM"
            src="assets/MercerPrm.png"
            width="100%"
            style="padding: 10px"
          />
        </div>
      </div>
    </div>

    <div class="form-group">
      <div class="row">
        @if (err && (err.status === 401 || err.status === 403)) {
        <div class="col-12 alert alert-danger">
          @if (err.status === 401) {
          <span i18n="@@authRequestNotAccepted">Anfrage wurde nicht akzeptiert.</span>
          }
          @if (err.status === 403) {
          <span i18n="@@authInvalidAccessCode">Bitte geben Sie einen gültigen Zugangcode ein</span>
          }
        </div>
        }
        @if (this.waitingForLoginValidation) {
        <div class="col-12 alert alert-warning">
          <span i18n="@@authWaitingForModerator">Freischaltung bei Moderator angefragt. Bitte warten.</span>
        </div>
        }
        @if (this.invalidPin) {
        <div class="col-12 alert alert-danger">
          <span i18n="@@authInvalidPin">Ungültiger Zugangscode</span>
        </div>
        }
        @if (this.isBlocked) {
        <div class="col-12 alert alert-danger">
          <span i18n="@@authTooManyAttempts">Zu viele Fehlversuche. Bitte warte noch {{blockedCountdownText}}.</span>
        </div>
        }
        <input
          #pincode
          maxlength="6"
          class="form-control ml-2 mb-4"
          style="
            color: #000;
            background-color: #fff;
            letter-spacing: 10px;
            text-align: center;
            border-radius: 10px;
            text-transform: uppercase;
          "
          i18n-placeholder="@@authPinPlaceholder"
          placeholder="PIN"
          [disabled]="isBlocked"
          (input)="onPinInput($event)"
        />
      </div>
    </div>
    <div class="form-group">
      <button
        id="login"
        #login
        i18n="@@authLoginButtonNoPp"
        class="btn btn-primary btn-block"
        type="submit"
        [disabled]="pincode.value.length < 6 || isBlocked"
      >
        Login
      </button>
    </div>
  </form>

  <div
    style="position: absolute; bottom: 16px; left: 50%; transform: translateX(-50%); display: flex; gap: 16px; white-space: nowrap;"
  >
    <a
      href="https://www.profil-m.de/ac-suite-datenschutz/"
      target="_blank"
      rel="noopener noreferrer"
      style="color: #aab0b8; font-size: 12px; text-decoration: none;"
      i18n="@@linkPrivacyPolicy"
    >Datenschutzhinweise</a>
    <a
      href="https://www.profil-m.de/impressum/"
      target="_blank"
      rel="noopener noreferrer"
      style="color: #aab0b8; font-size: 12px; text-decoration: none;"
      i18n="@@linkImprint"
    >Impressum</a>
  </div>

</div>